<script>
  import HeaderMini from "../components/HeaderMini.svelte";
  import Footer from "../components/Footer.svelte";
  import { Article, Table, Breadcrumb, Pagination } from "spaper";
  import { navigate } from "svelte-routing";
  import { getAdoptionRequests, showErrorThenCallback } from "../utils/utils";
  import { strings } from "../constants/strings";
  import { onMount } from "svelte";

  let adoptionRequests = [];
  let totalRequests = 0;
  let noRequestsMessage = "Cargando...";
  const requestsToShow = 20; // This must be in sync with LIMIT value on DB
  const breadcrumbPath = [
    {
      text: "Administrador",
      href: "/_admin"
    },
    {
      text: "Solicitudes",
      href: "/_adoptionrequests"
    }
  ];
  const tableColumns = [
    {field: "attended", label: "Estatus", content:x => x ? "Atendida" : "<b>SIN ATENDER</b>", html: true},
    {field: "adoptable", label: "Adoptable", content:x => x.name},
    {field: "name", label: "Solicitante"},
    {field: "date", label: "Fecha", content: x => new Date(x).toDateString()},
    {field: "_id", label: "Detalles", content:x => `<a href="/_adoptionrequest/${x}">Ver</a>`, html: true}
  ];

  const loadMore = async (ev) => {
    try {
      let resp = await getAdoptionRequests(`p=${ev.detail-1}`);
      adoptionRequests = resp.requests;
    } catch (errorMessage) {
      showErrorThenCallback(errorMessage, () => { navigate("/_admin") });
    }
  };

  onMount(async () => {
    let resp;
    try {
      resp = await getAdoptionRequests();
      adoptionRequests = resp.requests;
      totalRequests = resp.total;
      if (!adoptionRequests.length) {
        noRequestsMessage = strings.genericMessages.warning.noAdoptionRequestsFound;
      }
    } catch (errorMessage) {
      showErrorThenCallback(errorMessage, () => { navigate("/_admin") });
    }
  });
</script>

<HeaderMini />
<Breadcrumb items={breadcrumbPath} />
<Article title="Solicitudes de Adopción">
  {#if adoptionRequests.length > 0}
    <Table data={adoptionRequests} columns={tableColumns} />
  {:else}
    <h3>{noRequestsMessage}</h3>
  {/if}
  {#if totalRequests > requestsToShow}
    <div class="pagination-area">
      <Pagination pageSize={requestsToShow} total={totalRequests} on:change={loadMore} />
    </div>
  {/if}
</Article>
<Footer />

<style>
  .pagination-area {
    display: block;
    margin: auto;
    text-align: center;
  }
</style>